import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  ModalFooter,
} from "reactstrap";

import { RestroUsers } from "../../../../services/DatabaseService/RestroUsers";
import { BreadCrumb } from "../../component/BreadCrumb";
import { Link, useNavigate } from "react-router-dom";
import CustomDataTable from "../../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import { formatDateTime } from "../../../../Components/Common/FormatDate";
import RestroPayment from "../../../../services/DatabaseService/RestroPayment";
import toast from "react-hot-toast";
import ContactPersonForm from "../component/ContactPersonForm";

export default function RestroUsersInfo() {

  const router = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState([]);

  const [filterTenantName, setFilterTenantName] = useState("");
  const [filterTenantCode, setFilterTenantCode] = useState("");
  const [filterIsActive, setFilterIsActive] = useState(null);
  const [registeredDateRange, setRegisteredDateRange] = useState([]);
  const [validDateRange, setValidDateRange] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filterBoolean, setFilterBoolean] = useState(true);
  const [graceDays, setGraceDays] = useState("");
  const [remarks, setRemarks] = useState("");
  const [amount, setAmount] = useState("");
  const [paymentType, setPaymentType] = useState("")
  const [bankname, setBankName] = useState("");
  const [validTill, setValidTill] = useState("");
  console.log("🚀 ~ RestroUsersInfo ~ validTill:", validTill)
  const [selectedUser, setselectedUser] = useState(null);
  // const [activeclients,setactiveclients] = useState("");
  // const [inactiveclients,setinactiveclients] = useState("");
  // const [extendeddate,setextendeddate] = useState("");
  // const [paymentlogs,setpaymentlogs] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [paymentmodal, setPaymentModal] = useState(false);
  const [contactmodal, setContactModal] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  const togglePaymentModal = () => setPaymentModal(!paymentmodal)


  const fetchData = async (
    tenantName = filterTenantName,
    tenantCode = filterTenantCode,
    status = filterBoolean,
    registeredStart,
    registeredEnd,
    validStart,
    validEnd
  ) => {
    // console.log(status)
    setLoading(true);
    try {
      console.log(registeredStart, registeredEnd);
      console.log("fired");
      const result = await RestroUsers.getAll({
        tenantName: tenantName,
        tenantCode: tenantCode,
        IsActive: status,
        RegisteredDateFrom: registeredStart,
        RegisteredDateTo: registeredEnd,
        ValidDateFrom: validStart,
        ValidDateTo: validEnd,
      });
      console.log(result);
      setDataList(result || []);
    } catch (error) {
      console.error("Failed to load data:", error);
      setDataList([]);
    } finally {
      setLoading(false);
    }
  };


  const wrapByComma = (text) => {
  return text?.replace(/,/g, ',\u200B');  // allow break only after comma
};


  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  let registeredStart, registeredEnd, validStart, validEnd;

  if (registeredDateRange.length === 2) {
    [registeredStart, registeredEnd] = registeredDateRange.map(formatDate);
  }

  if (validDateRange.length === 2) {
    [validStart, validEnd] = validDateRange.map(formatDate);
  }

  useEffect(() => {
    if (registeredDateRange.length === 2 || validDateRange.length === 2) {
      let registeredStart, registeredEnd, validStart, validEnd;

      if (registeredDateRange.length === 2) {
        [registeredStart, registeredEnd] = registeredDateRange.map(formatDate);
      }

      if (validDateRange.length === 2) {
        [validStart, validEnd] = validDateRange.map(formatDate);
      }

      fetchData(
        filterTenantName,
        filterTenantCode,
        filterBoolean,
        registeredStart,
        registeredEnd,
        validStart,
        validEnd
      );
    }
  }, [
    registeredDateRange,
    validDateRange,
    filterTenantName,
    filterTenantCode,
    filterBoolean,
  ]);

  // Unified fetch function

  useEffect(() => {
    fetchData(filterTenantName, filterTenantCode);
  }, [filterTenantName, filterTenantCode]);

  const [addModal, setAddModal] = useState(false);

  const filteredData = dataList.filter(
    (item) =>
      (item.name?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      ) ||
      (item.database?.toLowerCase() || "").includes(
        filterText?.toLowerCase() || ""
      )
  );

  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
        width: "max-content",
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const openUpdateGraceModal = (user) => {
    // console.log("Key updated")
    setselectedUser(user);
    setGraceDays(7);
    console.log(selectedUser)
    setModalOpen(true); // store the selected user
    // toggleModal();  
    // open modal
  };

  const handleUpdateGracePeriod = async () => {
    console.log("fired")
    if (!selectedUser) return;
    console.log("user selected")
    const payload = {
      apikey: selectedUser.apiKey,
      gracePeriodDays: Number(graceDays),
      remarks: remarks

    };
    try {
      // console.log(apikey);
      const response = await RestroPayment.Graceupdate(payload);
      console.log(response);


      //update valid till after change
      let newValidTill = selectedUser.validTill;
      if (!response?.validTill) {
        const date = new Date(selectedUser.validTill);
        date.setDate(date.getDate() + Number(graceDays));
        newValidTill = date.toISOString();
      } else {
        newValidTill = response.validTill;
      }

      // 🔹 Update local state immediately
      setDataList(prevList =>
        prevList.map(user =>
          user.apiKey === selectedUser.apiKey
            ? { ...user, validTill: newValidTill }
            : user
        )
      );


      setModalOpen(false);
      setGraceDays("");
      setRemarks("");
    } catch (error) {
      console.log(error);
    }
    toast.success("Valid Date Extended Successfully");
    // console.log("API KEY:", row.apiKey);
  };

  // const handleExtendDate = (row) => {
  //   console.log("Extend date for:", row.apiKey);
  // };

  const openAddPaymentModal = (user) => {
    console.log("Open Payment Modal");
    setselectedUser(user);
    console.log(user)
    setPaymentModal(true);
  };

  const handleAddPaymentModal = async () => {
    console.log("New Payment Fetch");
    if (!selectedUser) return;
    const payload = {

      apiKey: selectedUser.apiKey,
      amount: amount,
      newValidTill: validTill,
      paymentType: Number(paymentType),
      bankName: bankname


    };
    console.log(payload)

    try {
      const response = await RestroPayment.AddPayment(payload);
      console.log(response);

      setDataList(prevList =>
        prevList.map(user =>
          user.apiKey === selectedUser.apiKey
            ? {
              ...user,
              validTill: validTill // or response.validTill if API returns updated value
            }
            : user
        )
      );
      toast.success("Payment Added Sucessfully")


    } catch (error) {
      console.log(error);
    } finally {
      setPaymentModal(false);
      setAmount("");
      setPaymentType("");
      setBankName("");
      setValidTill("");
    }
  }


  const columns = [
    {
      name: "S No",
      cell: (row, index) => <div >{index + 1}</div>,
      width: "65px",
      // sortable: true,
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.tenantName,
      sortable: true,
      width: "210px",
      cell: (row) => (
        <div style={{ whiteSpace: "wrap" }}>
          <strong>
            <Link
              // to={`/restrolog/detail/${row.apiKey}`}
              to={`/restrouserlog/detail/${row.apiKey}`}
              className="text-primary"
              style={{ textDecoration: "none" }}
              title={row.tenantName}
            ><span title={row.tenantName}>{row.tenantName}</span></Link></strong>
          <br />
          <small className="text-muted">{row.tenantCode}</small>
        </div>
      ),
    },


    {
      name: "Address",
      selector: (row) => <span title={row.address} className="d-block text-wrap text-break">
        {row.address}
      </span>,
      // width:"150px",
      sortable: true,
    },
    {
      name: "Registered Date",
      selector: (row) => formatDateTime(row.regsiteredDate),
      cell: (row) => {
        const dateObj = new Date(row.regsiteredDate);
        const date = dateObj.toLocaleDateString("en-GB"); // e.g., 26/09/2025
        const time = dateObj.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }); // e.g., 07:42:10

        return (
          <div>
            {date}
            <br />
            {/* {time} */}
          </div>
        );
      },
      width: "162px",
      sortable: true,
    },

    {
      name: "Phone No",
      selector: (row) => <span title={row.phone} className="d-block text-break">{wrapByComma(row.phone)}</span>,
      sortable: true,
      wrap: true,
      width: '120px'
    },
    {
      name: "Valid Till",
      selector: (row) => formatDateTime(row.validTill),
      sortable: true,
      cell: (row) => {
        const dateObj = new Date(row.validTill);
        const date = dateObj.toLocaleDateString("en-GB"); // e.g., 26/09/2025
        const time = dateObj.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }); // e.g., 07:42:10

        return (
          <div>
            {date}
            {/* <br />
            {time} */}
          </div>
        );
      },
      width: "120px"
    },
    {
      name: "Status",
      selector: "isActive",
      sortable: true,
      width: "95px",
      cell: (row) => (
        <span
          className={`badge ${row.isActive ? "bg-success" : "bg-danger"
            }`}

        >
          {row.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <Link to={`/restrouserinfo/update/${row.apiKey}`}>
            <Button color="btn btn-soft-warning" className="btn-sm ms-1">
              <i className="ri-edit-line " />
            </Button>
          </Link>

          {/* <Link to={`/restrolog/detail/${row.apiKey}`}>
            <Button color="btn btn-soft-success" className="btn-sm ms-1">
              <i className="ri-eye-line" />
            </Button>
          </Link> */}


          <Button color="btn btn-soft-success" className="btn-sm ms-1" onClick={() => openUpdateGraceModal(row)}>
            <i className="ri-timer-2-line" />
          </Button>

          <Button color="btn btn-soft-success" className="btn-sm ms-1" onClick={() => openAddPaymentModal(row)}>
            <i className="ri-bank-card-line" />
          </Button>


          {/* <Link to ={`/restrouserinfo/extend/${row.apiKey}`}> */}
          {/* <Button color = "btn btn-soft-info" className="btn-sm ms-1">
            <i className="ri-time-line"/>
          </Button> */}
          {/* <UncontrolledDropdown>
            <DropdownToggle
              color="info"
              tag="button"
              className="btn btn-soft-info btn-sm ms-1"
              caret={false}
            >
              <i className="ri-time-line" />
            </DropdownToggle>

            <DropdownMenu

              className="border border-dark rounded-2 shadow-sm">
              <DropdownItem onClick={() => openUpdateGraceModal(row)}>
                <i className="ri-edit-line me-2" />Update Grace Period
              </DropdownItem>

              <DropdownItem onClick={() => openAddPaymentModal(row)}>
                <i className="ri-calendar-line me-2" /> Add Payment
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown> */}
          {/* </Link> */}
        </div>
      ),
      width: "100px",
      center: true,
    },
  ];


  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Restro User Info" pageTitle="Database" />
      </div>

      {/* Filters */}
      <Row className="mb-3 align-items-end">
        <Col md={3} className="mb-2">
          <Input
            placeholder="Search by TenantName"
            value={filterTenantName}
            onChange={(e) => setFilterTenantName(e.target.value)}
          />
        </Col>

        <Col md={3} className="mb-2">
          <Input
            placeholder="Search by TenantCode"
            value={filterTenantCode}
            onChange={(e) => setFilterTenantCode(e.target.value)}
          />
        </Col>

        <Col md={2} className="mb-2">
          <Flatpickr
            className="form-control"
            placeholder="Registered Date"
            value={registeredDateRange}
            onChange={(dates) => setRegisteredDateRange(dates)}
            options={{
              mode: "range",
              dateFormat: "Y-m-d",
            }}
          />
        </Col>

        <Col md={2} className="mb-2">
          <Flatpickr
            className="form-control"
            placeholder="Valid Date"
            value={validDateRange}
            onChange={(dates) => setValidDateRange(dates)}
            options={{
              mode: "range",
              dateFormat: "Y-m-d",
            }}
          />
        </Col>

        <Col md={1} className="mb-2 d-flex align-items-center">
          <div className="form-check mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              id="filterBoolean"
              checked={filterBoolean}
              onChange={(e) => {
                const newValue = !filterBoolean;
                setFilterBoolean(newValue);
                fetchData(filterTenantName, filterTenantCode, newValue);
              }}
            />
            <label className="form-check-label pb-2" htmlFor="filterBoolean">
              Active
            </label>
          </div>
        </Col>
      </Row>

      {/* Desktop Table */}
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData || []}
          />
        </CardBody>
      </Card>

      {/* Mobile Table - Scrollable */}
      <Card className="d-block d-lg-none">
        <CardBody className="p-0">
          <div style={{ overflowX: "auto" }}>
            <CustomDataTable
              responsive
              striped
              pagination
              paginationRowsPerPageOptions={[10, 15, 20, 30, 45, 50, 75, 100]}
              fixedHeader
              persistTableHead
              progressPending={loading}
              customStyles={customStyles}
              progressComponent={
                <div className="my-3">
                  <Triangle
                    visible={true}
                    height="80"
                    width="80"
                    color="#5B71B9"
                    ariaLabel="triangle-loading"
                  />
                  <h5 className="mt-1">Loading...</h5>
                </div>
              }
              columns={columns}
              data={filteredData || []}
            />
          </div>
        </CardBody>
      </Card>

      {/* Loading State */}
      {loading && (
        <div className="my-5 d-flex justify-content-center">
          <h5 className="mt-1">Loading...</h5>
        </div>
      )}

      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>
          Update Grace Period
        </ModalHeader>
        <ModalBody>
          <Label>Grace Period Days</Label>
          <Input
            type="number"
            value={graceDays}
            onChange={(e) => setGraceDays(e.target.value)}
            placeholder="Enter number of days"
          />
          <Label className="mt-2">Remarks</Label>
          <Input
            type="text"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Enter remarks"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleUpdateGracePeriod}>
            Submit
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>


      {/* Add Payment Modal */}
      <Modal isOpen={paymentmodal} toggle={togglePaymentModal}>
        <ModalHeader toggle={togglePaymentModal}>
          Add Payment
        </ModalHeader>

        <ModalBody>
          <Label>Payment Amount</Label>
          <Input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter payment Amount"
          />
          <Label className="mt-2">Payment Type</Label>
          <Input
            type="select"
            value={paymentType}
            onChange={(e) => setPaymentType(e.target.value)}
          >
            <option value="">Select Payment Type</option>
            <option value="1">Cheque</option>
            <option value="2">Online</option>
            <option value="3">Cash</option>
          </Input>
          <Label className="mt-2">Bank Name</Label>
          <Input
            type="text"
            value={bankname}
            onChange={(e) => setBankName(e.target.value)}
            placeholder="Enter Bank Name"
          />
          <Label className="mt-2">Valid Till</Label>
          {/* <Input
            type="Valid Till"
            value={validTill}
            onChange={(e) => setValidTill(e.target.value)}
            placeholder="Enter Bank Name"
          /> */}
          <div className="input-group">


            <Flatpickr
              className="form-control border-1 dash-filter-picker shadow"
              options={{
                dateFormat: "d M, Y",
                defaultDate: selectedUser?.validTill ? new Date(selectedUser.validTill) : null,
              }}
              value={validTill
                ? new Date(validTill)     // after selecting new date
                : selectedUser?.validTill  // initially show old date
                  ? new Date(selectedUser.validTill)
                  : null}
              onChange={(date) => {
                setValidTill(date[0] ? date[0].toISOString() : null);
              }}
              placeholder="Select date"
            />

            <div className="input-group-text bg-primary border-primary text-white"><i className="ri-calendar-2-line"></i></div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleAddPaymentModal}>
            Submit
          </Button>
          <Button color="danger" onClick={togglePaymentModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <ContactPersonForm
        modalOpen={contactmodal}
        toggleModal={() => setContactModal(false)}
        apikey={selectedUser?.apikey}
      />
    </div>
  );
}
